export const PageTitle = ({ children }: any) => {
    return (
        <h5 className="mb-4 font-bold text-2xl mx-auto">{children}</h5>
    )
}